import { IChartDataItem } from '../components/Chart/SurveyChart';

const minGrades = [
  {
    name: 'درجه عالی',
    l1: 0,
    l2: 0,
    l3: 0,
    i: 80,
    b2: 85,
    t: 85,
    a: 80,
    b: 80,
    c: 80,
  },
  {
    name: 'درجه یک برتر',
    l1: 0,
    l2: 0,
    l3: 0,
    i: 70,
    b2: 75,
    t: 75,
    a: 70,
    b: 70,
    c: 70,
  },
  {
    name: 'درجه یک',
    l1: 68,
    l2: 55,
    l3: 41,
    i: 60,
    b2: 65,
    t: 65,
    a: 0,
    b: 0,
    c: 0,
  },
  {
    name: 'درجه دو',
    l1: 61,
    l2: 45,
    l3: 0,
    i: 55,
    b2: 60,
    t: 60,
    a: 0,
    b: 0,
    c: 0,
  },
  {
    name: 'درجه سه',
    l1: 53,
    l2: 35,
    l3: 0,
    i: 50,
    b2: 52,
    t: 52,
    a: 0,
    b: 0,
    c: 0,
  },
  {
    name: 'درجه چهار',
    l1: 51,
    l2: 21,
    l3: 0,
    i: 50,
    b2: 48,
    t: 48,
    a: 0,
    b: 0,
    c: 0,
  },
  {
    name: 'بدون درجه',
    l1: 0,
    l2: 0,
    l3: 0,
    i: 0,
    b2: 0,
    t: 0,
    a: 0,
    b: 0,
    c: 0,
  },
];

export const degreeOptions = minGrades.map((it) => it.name);
export function calculateHospitalDegre(data: Required<IChartDataItem>) {
  const l1 = Number(data['سطح ۱']) || 0;
  const l2 = Number(data['سطح ۲']) || 0;
  const l3 = Number(data['سطح ۳']) || 0;
  const a = Number(data['الف. رهبری و مدیریت']) || 0;
  const b = Number(data['ب. مراقبت و درمان']) || 0;
  const c = Number(data['ج. حمایت از گیرنده خدمت']) || 0;
  const i = Number(data['ایمنی']) || 0;
  const t = Number(data['اعتباربخشی']) || 0;
  const b2 = Number(data['ب.۲ مراقبت های حاد و اورژانس']) || 0;
  for (let j = 0; j < minGrades.length; j++) {
    if (
      l1 >= minGrades[j].l1 &&
      l2 >= minGrades[j].l2 &&
      l3 >= minGrades[j].l3 &&
      a >= minGrades[j].a &&
      b >= minGrades[j].b &&
      c >= minGrades[j].c &&
      i >= minGrades[j].i &&
      t >= minGrades[j].t &&
      b2 >= minGrades[j].b2
    )
      return minGrades[j].name;
  }
  return 'بدون درجه';
}
